import './style.css'

import ReactDOM from 'react-dom/client'
import { Suspense } from 'react'
import { DSLloader } from './dslLoader.tsx'
import { Analytics } from '@vercel/analytics/react'
import App from './app'


const root = ReactDOM.createRoot(document.querySelector('#root'));
root.render(
    <Suspense fallback={<DSLloader />}>
        <App />
        <Analytics/>
    </Suspense>
);


